var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMainLogoEng(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 186,
    height: 40,
    viewBox: "0 0 186 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_454_1238)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.7195 28.6895V11.3636H29V28.6895H33.7195ZM58.7275 28.6895V11.3636H54.4962L49.1257 20.1329H49.0715L43.6468 11.3636H39.307V28.6895H43.918V20.3455H44.0265L48.0408 26.7762H49.7225L53.7368 20.3455H53.9537V28.6895H58.7275ZM75.2729 17.9539H69.0345V15.2434H79.3957V11.3636H64.315V28.6895H79.9924V24.8098H69.0345V21.7273H75.2729V17.9539ZM92.1981 28.6895C95.6699 28.6895 97.894 27.7329 99.4672 26.2448C101.095 24.7035 101.963 22.4713 101.963 20.0266C101.963 17.6881 101.149 15.5622 99.6299 13.9678C98.0025 12.2671 95.5614 11.3636 92.2523 11.3636H84.1152V28.6895H92.1981ZM88.7805 24.7567V15.2434H92.0896C94.0425 15.2434 94.9647 15.7217 95.7241 16.5189C96.5378 17.3692 97.0261 18.4853 97.0261 20.0266C97.0261 21.621 96.5378 22.7371 95.6156 23.5874C94.8562 24.3315 93.934 24.7035 92.0896 24.7035H88.7805V24.7567ZM110.913 28.6895V11.3636H106.194V28.6895H110.913Z",
    fill: "#073269"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M132.666 11.8951V27.4671H145.848V23.9594H136.951V11.8951H132.666ZM138.579 1C143.949 1 148.777 3.12587 152.303 6.58042C155.829 10.035 157.999 14.765 157.999 20.0266C157.999 25.2881 155.829 30.0182 152.303 33.4727C148.777 36.9273 143.949 39.0531 138.579 39.0531C133.208 39.0531 128.38 36.9273 124.854 33.4727C121.328 30.0182 119.158 25.2881 119.158 20.0266C119.158 14.765 121.328 10.035 124.854 6.58042C128.38 3.12587 133.262 1 138.579 1Z",
    fill: "#073269"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_454_1238"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 129,
    height: 38,
    fill: "white",
    transform: "translate(29 1)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainLogoEng);
export default __webpack_public_path__ + "static/media/main-logo-eng.1d8f1cb4a12e8f828ff821cd2ec53e35.svg";
export { ForwardRef as ReactComponent };